import ai from '@/assets/images/fileIcons/ai.png'
import archive from '@/assets/images/fileIcons/archive.png'
import audio from '@/assets/images/fileIcons/audio.png'
import catalog from '@/assets/images/fileIcons/catalog.png'
import file from '@/assets/images/fileIcons/file.png'
import excel from '@/assets/images/fileIcons/excel.png'
import code from '@/assets/images/fileIcons/code.png'
import img from '@/assets/images/fileIcons/img.png'
import pdf from '@/assets/images/fileIcons/pdf.png'
import ppt from '@/assets/images/fileIcons/ppt.png'
import ps from '@/assets/images/fileIcons/ps.png'
import txt from '@/assets/images/fileIcons/txt.png'
import video from '@/assets/images/fileIcons/video.png'
import word from '@/assets/images/fileIcons/word.png'

// 文件扩展名-图标
var extMap = {
	// 文件
	file: file,
	// 目录
	catalog: catalog,
	// 文本
	txt: txt,
	// 文档
	doc: word,
	docx: word,
	docm: word,
	dotx: word,
	pages: word, // iwork
	// 表格
	xlt: excel,
	xls: excel,
	xlsx: excel,
	xlsm: excel,
	xltx: excel,
	xltm: excel,
	xlsb: excel,
	xlam: excel,
	numbers: excel, // iwork
	// ppt
	ppt: ppt,
	pptx: ppt,
	pptm: ppt,
	key: ppt, // iwork keynote
	// pdf
	pdf: pdf,
	// 视频
	avi: video,
	wmv: video,
	mpg: video,
	mpeg: video,
	mov: video,
	rm: video,
	ram: video,
	swf: video,
	mp4: video,
	// 音频
	mid: audio,
	midi: audio,
	au: audio,
	aif: audio,
	aiff: audio,
	snd: audio,
	wav: audio,
	mp3: audio,
	// 代码
	md: code,
	html: code,
	xml: code,
	js: code,
	css: code,
	scss: code,
	sass: code,
	less: code,
	py: code,
	java: code,
	php: code,
	// 图片
	bmp: img,
	jpg: img,
	jpeg: img,
	png: img,
	tif: img,
	gif: img,
	pcx: img,
	tga: img,
	exif: img,
	fpx: img,
	svg: img,
	psd: img,
	cdr: img,
	pcd: img,
	dxf: img,
	ufo: img,
	raw: img,
	wmf: img,
	webp: img,
	// 绘图
	ai: ai,
	ps: ps
}

// office365支持的文件类型
var office365 = {
    // word
    doc: true,
    docx: true,
    rtf: true,
    // excel
    xls: true,
    xlsx: true,
    // ppt
    ppt: true,
    pptx: true,
    // pdf
    pdf: true,
    // wps
    wps: true,
    // txt
    txt: true,
    // 压缩包
    zip: true,
    rar: true,
    "7z": true
}

// 文件扩展名相关接口
export default {
	methods: {
		// 获取扩展名对应图标
		getExtIcon(ext) {
			var url = extMap[ext]

			return url ? url : extMap.file
		},
		// 判断该扩展名是否为图片
		isImg(ext) {
			var url = extMap[ext]

			return url === img
		},
		// 获取文件扩展名
		getExtName(name) {
			return name.split(".").pop().toLocaleLowerCase()
		},
		// 是否支持365预览
		isOffice365(ext){
			return office365[ext]
		},
	}
}